export default __webpack_public_path__ + "static/media/marketing.03d2937b.svg";